import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";
import EventTypes from "../../../shared/EventTypes";

export default class ReshapePolyShapeAction extends AbstractProvidedClass {
    movedX = 0;
    movedY = 0;

    constructor(provider, elementPart) {
        super(provider);

        this.elementPart = elementPart;

        // Store initial offset between element and mouse for smooth absolute tracking
        let mouseAbsX = (this.p.mouseX - this.view.posX) / this.view.scale;
        let mouseAbsY = (this.p.mouseY - this.view.posY) / this.view.scale;
        this.offsetX = elementPart.absX - mouseAbsX;
        this.offsetY = elementPart.absY - mouseAbsY;
    }

    update() {
        let moveX, moveY;
        if (this.settings.snapToGrid) {
            [moveX, moveY] = this.view.snappedCoordinate.diff(this.elementPart);
        } else {
            let mouseAbsX = (this.p.mouseX - this.view.posX) / this.view.scale;
            let mouseAbsY = (this.p.mouseY - this.view.posY) / this.view.scale;
            moveX = mouseAbsX + this.offsetX - this.elementPart.absX;
            moveY = mouseAbsY + this.offsetY - this.elementPart.absY;
        }
        if (moveX != 0 || moveY != 0) {
            this.movedX += moveX;
            this.movedY += moveY;
            this.elementPart.drag(moveX, moveY);
        }
    }

    finish() {
        if (this.movedX == 0 && this.movedY == 0) {
            this.actions.discard();
        } else {
            this.actions.finish();
            this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.elementPart.parent);
        }
    }

    undo() {
        this.elementPart.drag(-this.movedX, -this.movedY);
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.elementPart.parent);
    }

    redo() {
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.elementPart.parent);
        this.elementPart.drag(this.movedX, this.movedY);
    }
}
